<template>
<svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 70.402 70.402">
  <g id="Group_312" data-name="Group 312" transform="translate(-594.989 -280.286)">
    <circle id="Ellipse_243" data-name="Ellipse 243" cx="35.201" cy="35.201" r="35.201" transform="translate(594.989 280.286)" fill="#fff"/>
    <path id="Path_502" data-name="Path 502" d="M644.8,311.962v21.632H615.583V311.962" fill="none" stroke="#1a1818" stroke-miterlimit="10" stroke-width="3"/>
    <rect id="Rectangle_226" data-name="Rectangle 226" width="12.563" height="8.067" transform="translate(624.501 299.074) rotate(-45)" fill="#1a1818"/>
    <path id="Path_503" data-name="Path 503" d="M641.979,302.445h-5.206l-2.34,2.34h2.387l.921,2.973H622.647l.937-2.973H626l-2.34-2.34h-5.253l-4.324,9.519H646.3Z" fill="#1a1818"/>
  </g>
</svg>
</template>

<script>
export default {
  'name': 'SA_01_01',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/attributes/SA_01_01.vue